module.exports = __webpack_public_path__ + "img/user-bg-img.acf903a5.png";